<template>
  <div
    v-show="$register && allowCashPurchase && order.total && order.remainingOwed && !paymentConnectorPaymentInProgress"
  >
    <q-btn
      color="green"
      class="q-py-xs q-mx-xs q-mt-sm quick-cash-button"
      :class="$q.screen.lt.sm ? 'col-5' : ''"
      :disable="cashSessionLoading || !!order.errors || !exactCashAmount"
      :outline="split"
      dense
      @click="$emit('add-cash',exactCashAmount, true)"
    >
      Pay&nbsp;
      <i18n-n
        :value="exactCashAmount"
        format="currency"
      />
      &nbsp;Cash
      <q-inner-loading :showing="cashSessionLoading" />
    </q-btn>

    <q-btn
      v-for="amount in quickCashAmountOptions"
      :key="amount"
      class="q-px-sm q-mt-sm q-py-xs quick-cash-button"
      :class="$q.screen.lt.sm ? 'col-5' : ''"
      color="green"
      outline
      dense
      :disable="cashSessionLoading"
      @click="$emit('add-cash', amount)"
    >
      +
      <i18n-n
        :value="amount"
        :format="Math.round(amount) === amount ? 'currencyNoCents' : 'currency'"
      />
      <q-inner-loading :showing="cashSessionLoading" />
    </q-btn>

    <q-btn
      color="green"
      class="q-px-md quick-cash-button q-py-xs q-mt-sm"
      :class="$q.screen.lt.sm ? 'col-5' : ''"
      outline
      dense
      label="Cash"
      :disable="cashSessionLoading"
      @click="$emit('edit-cash')"
    >
      <q-inner-loading :showing="cashSessionLoading" />
    </q-btn>
  </div>
</template>

<script>
export default {
  name: 'CashButtonsSection',

  props: {
    order: {
      type: Object,
      required: true
    },
    allowCashPurchase: {
      type: Boolean,
      required: false,
      default: true
    },
    paymentConnectorPaymentInProgress: {
      type: Boolean,
      required: false,
      default: false
    },
    cashSessionLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    quickCashAmountOptions: {
      type: Array,
      required: false,
      default: null
    },
    exactCashAmount: {
      type: Number,
      required: false,
      default: 0
    },
    split: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['add-cash', 'edit-cash']
}
</script>
